import { reactive } from 'vue';
import { Options } from 'vue-class-component';

import config from '@/config/config';
import PageBaseList from '@/pages/PageBaseList';
import TableLite from '@/components/table/TableLiteTs.vue';
import * as TypeMediaService from '@/services/type-media.service';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';
import { ITypeMedia } from '@/domain/type-media.model';

@Options({
  name: 'type-media-list',
  components: {
    TableLite,
  },
})
export default class TypeMediaList extends PageBaseList {
  public table = TABLE;

  public mounted(): void {
    this.url = 'type-media';
    this.module = config.modules.typeMedia;
    this.table.rows = [];

    this.doSearch(0, this.per_page, 'id', 'asc');
  }

  public doSearch(
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ) {
    this.table.isLoading = true;

    this.table.isReSearch = offset == undefined ? true : false;
    if (offset >= 10 || limit >= this.per_page) {
      limit = this.per_page;
    }

    TypeMediaService.list(offset, limit, order, sort, filter).then((res: IPaginateVueTable<ITypeMedia>) => {
      this.table.rows = res?.data;
      this.table.totalRecordCount = res?.total;
      this.table.sortable.order = order;
      this.table.sortable.sort = sort;
    });
  }
}

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  columns: [
    {
      label: 'Id',
      field: 'id',
      sortable: true,
      isKey: true,
    },
    {
      label: 'Tag',
      field: 'tag',
      sortable: true,
      columnStyles: 'text-align: left',
    },
    {
      label: 'Tempo',
      field: 'time',
      sortable: true,
    },
    {
      label: 'Tipo de documento',
      field: 'type_description',
      sortable: true,
    },
    {
      label: 'Ativo',
      field: 'enabled',
      sortable: true,
    },
    {
      field: 'actions',
    },
  ],
  rows: [{}],
  totalRecordCount: 0,
  sortable: {
    order: 'id',
    sort: 'asc',
  },
});
